<template>
  <v-app>
    <component :is="layout">
      <transition name="fade">
        <router-view v-if="initialized" />
      </transition>
    </component>
    <snack-bar />
    <loader v-if="loading.state" />
  </v-app>
</template>

<script>
import SnackBar from '../components/snackbar'
import Loader from '../components/loader'
import { mapGetters } from 'vuex'
const default_layout = 'default'
export default {
  name: 'App',
  components: {
    SnackBar,
    Loader
  },
  data: () => ({
    initialized: true
  }),
  computed: {
    ...mapGetters({
      loading: 'general/loading'
    }),
    layout() {
      return (this.$route.meta.layout || default_layout) + '-layout'
    }
  }
}
</script>
